import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_ADMIN_USER_SUCCESS = "ADMIN_USER:UPSERT_ADMIN_USER_SUCCESS";

export interface UpsertAdminUserSuccessAction extends Action {
  type: typeof UPSERT_ADMIN_USER_SUCCESS;
  organization: OrganizationKeyName;
  id: string;
}

export const upsertAdminUserSuccessAction = (
  organization: OrganizationKeyName,
  id: string
): UpsertAdminUserSuccessAction => ({
  type: UPSERT_ADMIN_USER_SUCCESS,
  organization,
  id,
});
